import { type ReactNode } from 'react';

import { AdminBreadcrumb } from '@/components/admin/AdminBreadcrumb';
import { FlashMessages } from '@/components/admin/FlashMessages';
import { Sidebar } from '@/components/admin/Sidebar';
import { StatsHeader } from '@/components/admin/StatsHeader';

export default function AdminLayout({ children }: { children: ReactNode }) {
  return (
    <div className="bg-background flex min-h-screen flex-col">
      <StatsHeader />
      <div className="flex min-h-0 flex-1">
        <Sidebar />
        <main className="flex-1 overflow-auto p-6">
          <AdminBreadcrumb />
          <FlashMessages />
          {children}
        </main>
      </div>
    </div>
  );
}
